import React from 'react'
import { Grid, Button } from 'semantic-ui-react'
import InputNumber from 'components/inputs/InputNumber'
import InputNumberFrequency from 'components/inputs/numberfrequency'
import '../../../style.css'

const RolloverRowProperty = ({ event, onChange, /* onDelete, */ setYes, setNo, altRow }) => {
  if (!event) return null
  let rowBG = ''
  if (event.process<-1 && altRow) {
    rowBG = 'rgba(204, 204, 204, 0.8)'
  } else if (event.process<-1) {
    rowBG = '#cccccc' 
  } else if (altRow) {
    rowBG = 'rgba(238, 238, 238, 0.8)'
  } 
  return (
    <Grid.Row key={event.id} style={{backgroundColor: rowBG}} verticalAlign="middle">
      <Grid.Column width={5}>{event.desc}</Grid.Column> 
      <Grid.Column width={4}>
        { 
          event.action==='start' && 
          <div><InputNumber disabled={event.process === 0} id={event.id} limited={event.type!=='debt'} width={{ width: '120px' }} value={event.newValue} name='newValue' onChange={e => onChange(e, event.id)} /></div>
        }
      </Grid.Column>
      <Grid.Column width={4}>
        {
          event.action === 'end' ? 'Sold' : 
          <div><InputNumberFrequency disabled={event.process === 0} id={event.id} limited={event.type!=='debt'} width={{ width: '110px' }} numValue={event.otherValue} freqValue={event.otherFreq} onChange={e => onChange(e, event.id)} inputNumberName='otherValue' inputFreqName='otherFreq' /></div>            
        }
      </Grid.Column>
      <Grid.Column width={3}>
        <div style={{display:"flex"}}>
          <Button.Group style={{marginRight: '5px'}}>
            <Button positive={event.process>0} onClick={() => setYes(event.id)}>Yes</Button>
            <Button.Or />
            <Button negative={event.process===0} onClick={() => setNo(event.id, 0)}>No</Button>
            <Button.Or />
            <Button color={event.process===-1?'orange':''} onClick={() => setNo(event.id, -1)}>Undecided</Button>
          </Button.Group>
          {/* { (event.action==='start') && (event.process === 0) && <Button style={{marginLeft: 'auto'}} color='red' icon="trash alternate" onClick={() => onDelete(event.id)}/>}
          { (event.action==='start') && (event.process === -999)  && <Button style={{marginLeft: 'auto'}} color='orange' icon="undo alternate" onClick={() => onDelete(event.id)}/>}      */}           
        </div>
      </Grid.Column>
    </Grid.Row> 
  )
}

export default RolloverRowProperty